import { FILE_SIZE, BUSINESS_TYPE, BMS_TASK_TYPE } from '../utils/configuration';
import request from '@/utils/http';
import { getTaskRecall } from '../api/cost.js';
const INSTALL_FIFTTEN = '15';
const NETWORK_DISTRIBUTION = '21';
export const myXixins = {
    data() {
        return {
            businessTypeNum: '',
            downloadName: '',
            tellName: ''
        };
    },
    methods: {
        routeJump() {
            this.$message.closeAll();
            this.$message.warning('没有对应的单据编号，不允许查询数据详情');
            this.$router.push({ path: `/bms/cost` });
            this.visitedViews.forEach(e => {
                if (e.fullPath === this.$route.fullPath) {
                    this.$store.dispatch('delView', e);
                }
            });
        },
        proving(e) {
            this.tableDataLists[e].supplierAmount = this.tableDataLists[e].supplierAmount
                .replace(/[^\-\d.]/g, '').replace(/\b(0+){2,}/g, '0').replace(/\-{2,}/g, '-').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
            var index = -1;
            for (var i = 0; i < this.tableDataLists[e].supplierAmount.length; i++) {
                if (this.tableDataLists[e].supplierAmount[i] === '.') {
                    index = i;
                }
                if (index !== -1) {
                    if (i - index > 2) {
                        this.tableDataLists[e].supplierAmount = this.tableDataLists[e].supplierAmount.substring(0, i);
                    }
                }
            }
        },
        // 任务导出
        exportTaskDetail(text) {
            if (this.fineObj && this.fineObj.feeTaskType === BMS_TASK_TYPE.BILLING_DATA_TASK) { // 任务为计费类型
                if (this.fineObj.businessType === BUSINESS_TYPE.INSTALL) { // 业务为安装
                    this.businessTypeNum = INSTALL_FIFTTEN;
                } else if (this.fineObj.stationCode) { // 存在网点编码
                    this.businessTypeNum = NETWORK_DISTRIBUTION;
                } else {
                    this.businessTypeNum = this.fineObj.businessType;
                }
            }
            if (text === 'outlets') {
                this.downloadName = '网点配送任务';
            } else if (text === 'install') {
                this.downloadName = '安装任务';
            } else {
                this.downloadName = '任务';
            }
            var temp = {
                feeTaskCode: this.$route.query.feeTaskCode,
                businessType: this.businessTypeNum
            };
            request({
                url: '/api-bms-web/feeTask/exportTaskDetail',
                method: 'get',
                params: temp,
                responseType: 'arraybuffer'
            }).then(res => {
                const blob = new Blob([res], {
                    type: 'application/x-excel;charset=UTF-8'
                });
                const objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = objectUrl;
                a.download = `${this.downloadName}明细.xlsx`;
                a.click();
                document.body.removeChild(a);
                this.costNumber = '1';
            });
        },
        // 费用导出
        exportFeeDetail(text) {
            // 业务类型为3 4 10并且任务类型为计费数据任务 类型传1
            // 1 是运配  2 装卸  3 仓储  4 快递  5  手工预估 6安装 7网点配送
            // {1: "仓储", 2: "装卸", 3: "运输", 4: "配送", 5: "快递", 6: "其他业务", 7: "资产转卖", 10: "宅配", 11: "设备类"}
            if ((this.fineObj.businessType === '3' || this.fineObj.businessType === '4' || this.fineObj.businessType === '10') && (this.fineObj.feeTaskType === '10')) {
                this.tasktype = '1';
            } else if ((this.fineObj.feeTaskType === '10') && (this.fineObj.businessType === '2')) {
                this.tasktype = '2';
            } else if ((this.fineObj.feeTaskType === '10') && (this.fineObj.businessType === '1')) {
                this.tasktype = '3';
            } else if ((this.fineObj.feeTaskType === '10') && (this.fineObj.businessType === '5')) {
                this.tasktype = '4';
            } else if (this.fineObj.feeTaskType === '20') {
                this.tasktype = '5';
            }
            if (this.fineObj.feeTaskType === BMS_TASK_TYPE.BILLING_DATA_TASK) { // 任务为计费类型
                if (this.fineObj.businessType === BUSINESS_TYPE.INSTALL) { // 安装
                    this.tasktype = '6';
                } else if (this.fineObj.stationCode) { // 网点编码
                    this.tasktype = '7';
                }
            }
            if (text === 'outletsCost') {
                this.tellName = '网点配送费用';
            } else if (text === 'installCost') {
                this.tellName = '安装费用';
            } else {
                this.tellName = '任务';
            }
            var temp = {
                taskCode: this.$route.query.feeTaskCode,
                tasktype: this.tasktype
            };
            request({
                url: '/api-bms-web/feeTask/exportFeeDetail',
                method: 'get',
                params: temp,
                responseType: 'arraybuffer'
            }).then(res => {
                const blob = new Blob([res], {
                    type: 'application/x-excel;charset=UTF-8'
                });
                const objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = objectUrl;
                a.download = `${this.tellName}明细.xlsx`;
                a.click();
                document.body.removeChild(a);
            });
        },
        beforeUpload(file) {
            var fileNameArr = file.name.split('.');
            var fileType = fileNameArr[fileNameArr.length - 1];

            const Excel = fileType === 'xls' || fileType === 'xlsx';
            const isLt500KB = file.size / 1024 <= FILE_SIZE.FIVE_HUNDRED;

            if (!Excel) {
                this.$message.error('上传失败，文件格式只能为 xlsx 或 xls');
            } else if (!isLt500KB) {
                this.$message.error('上传文件大小不能超过 500KB');
            }
            return Excel && isLt500KB;
        },
        afterUpload(response) {
            if (response && response.code === '0') {
                this.$message.success('导入成功');
                this.load();
            }
        },
        goLists() {
            this.$router.push({ path: `/bms/cost` });
        },
        pageChange(page) {
            this.searchObj.pageNo = page;
            this.load();
        },
        pageChange2(page) {
            this.searchObjList.pageNo = page;
            this.getFeeDetails();
        },
        async withdraw() {
            this.recallLoading = true;
            await getTaskRecall(this.$route.query.feeTaskCode).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('撤回成功');
                }
                this.getData();
            }).finally(() => {
                this.recallLoading = false;
            });
        }
    }
};